export function createWork(data, isEmployee) {
    let { createWorkRequest, createWorkError, createWorkResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'create_work',
        this.createBundle('create_work', { work: data }, this.POST, createWorkRequest, createWorkResult, createWorkError, isEmployee)
    )
}
